// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"c4a46071","215":"c4a46071","351":"c4a46071","407":"c4a46071","409":"c4a46071"}[chunkId] + ".chunk.css";
};